module.exports = __webpack_public_path__ + "img/product_73.c89fc82.svg";